export default __webpack_public_path__ + "35067feaf325b2d06b322239b279fa57.svg";